import {ProductRatingStars} from "./components/ProductRatingStars";
import {ProductCTA} from "./components/ProductCTA";
import ProductShippingStatus from "./components/ProductShippingStatus";
import {ProductPackageSizes} from "./components/ProductPackageSizes";
import {ProductPrice} from "./components/ProductPrice";
import {ProductTags} from "./components/ProductTags";
import {ProductSubscriptionButton} from "./components/ProductSubscriptionButton";
import {HitProps} from "@shared/algolia/results/components/ResultComponents/hit-types";
import ProductName from './components/ProductName';
import ProductPresentationFormat from './components/ProductPresentationFormat';
import ProductPricePerUnit from './components/ProductPricePerUnit';
import ProductMandatoryInfo from './components/ProductMandatoryInfo';
import ProductImage from './components/ProductImage';
import {useProductCard} from "../../hooks/useProductCard";

export const ProductCardBlock = (props: HitProps | Readonly<HitProps>) => {
  const {
    hitState,
    imageWithFallback,
    packageSizesList,
    isRxProduct,
    isAvailable,
    subscriptionAvailable,
    productLink,
    onImageError,
    handleChangePackageSize,
    addToCart,
    addSubscription,
  } = useProductCard(props.hit);

  return (
    <div id="hit-list-item" className={`product-card`}>
      <ProductImage
        src={imageWithFallback}
        alt={hitState.name}
        isPromoted={!!hitState.isPromoted}
        eyecatcher={hitState.eyecatcher}
        onError={onImageError}
        productLink={productLink}
      />
      <ProductName productLink={productLink} name={hitState.name}/>
      <ProductRatingStars
        value={hitState.rating}
        count={Number(hitState.rating_count) || 0}
        isRxProduct={isRxProduct}
      />
      <div className="product-card__info-details">
        <ProductTags
          prescriptionRequired={hitState.prescription_required}
          herbal={hitState.herbal}
          homeopathic={hitState.homeopathic}
          display="block"
        />
        <ProductPresentationFormat presentationForm={hitState.presentation_form}/>
        <ProductPricePerUnit
          amountUnit={hitState.amount_unit}
          priceNoFormat={hitState.price_no_format}
          ppu={hitState.base_price}
        />
        <ProductMandatoryInfo productLink={productLink}/>
        <ProductShippingStatus
          statusNumber={hitState.status_number}
          statusText={hitState.status_text}
          statusInformation={hitState.status_information}
          productIndicator={hitState.products_indicator}
          prescriptionRequired={hitState.prescription_required === 1}
        />
      </div>
      <ProductPrice
        priceNoFormat={hitState.price_no_format}
        prescriptionRequired={hitState.prescription_required}
        avpFormatted={hitState.avp_formatted}
        avpNoFormat={hitState.avp_no_format}
        priceFormatted={hitState.price_formatted}
      />
      <ProductPackageSizes packageSizesList={packageSizesList} currentPackageSizePZN={hitState.pzn} changePackageSize={handleChangePackageSize}/>
      <ProductCTA isAvailable={isAvailable} isRxProduct={isRxProduct} handleOnClick={addToCart} productLink={productLink}/>
      {subscriptionAvailable && (
        <ProductSubscriptionButton
          isAvailable={isAvailable}
          subscriptionAvailable={subscriptionAvailable}
          handleOnClick={addSubscription}
          subscriptionSaving={hitState.subscription_savings}
        />
      )}
    </div>
  );
};